import React from "react";
import SiteSettings from ".";

export const siteSettingsRoutes = () => [
  {
    path: "/admin/site-settings",
    title: "site-settings",
    layout: "admin",
    routeType: "admin",
    component: SiteSettings,
  },
];
